import React from 'react'

// ─────────────────────────────────────────────────────────────────────────────
// PageCard , centered intro card for a section's <h1>.
//
//   <PageCard
//     icon={BookOpen}
//     kicker="Abstimmung bearbeiten"
//     title="Methodik und Prozesse"
//   />
//
// The kicker shows above the title in 10.5px uppercase orange.
// The icon goes in a peach 38×38 chip on the left of the content stack.
// ─────────────────────────────────────────────────────────────────────────────

export function PageCard({ icon: Icon, kicker, title, className = '' }) {
  return (
    <div
      className={
        'inline-flex items-center gap-3.5 mx-auto px-5 py-3.5 bg-white border border-[#e7e5df] ' +
        'rounded-[14px] shadow-[0_1px_2px_rgba(20,20,16,.03)] ' +
        'max-w-full ' +
        (className || '')
      }
    >
      {Icon && (
        <span className="grid place-items-center w-[38px] h-[38px] rounded-[10px] bg-[#fff1e8] text-[#e85d1f] flex-shrink-0">
          <Icon size={18} strokeWidth={1.75}/>
        </span>
      )}
      <div className="text-left min-w-0">
        {kicker && (
          <span className="block text-[10.5px] font-bold uppercase tracking-[0.10em] text-[#e85d1f] leading-tight">
            {kicker}
          </span>
        )}
        {title && (
          <span className="block text-[17px] font-semibold tracking-tight text-[#1a1816] leading-tight mt-0.5 truncate">
            {title}
          </span>
        )}
      </div>
    </div>
  )
}
